<template>
    <div>
        <client-header />
        <main class="client-main">
            <client-nav />
            <submission-process v-if="!isSuccess" />
            <submission-explain v-if="!isSuccess" />
            <slot />
        </main>
        <footer></footer>
    </div>
</template>
<script>
import clientNav from "@/components/client/client-nav.vue";
import ClientHeader from "../client/client-header.vue";
import SubmissionExplain from '../client/Submission/submission-explain.vue';
import SubmissionProcess from '../client/Submission/submission-process.vue';

export default {
    props:{
        isSuccess : {type: Boolean, default: false}
    },
    components: {
        clientNav,
        ClientHeader,
        SubmissionExplain,
        SubmissionProcess,
    },
    watch:{
        isSuccess(){
            this.isSuccess = this.isSuccess
        }
    }
};
</script>
<style lang="scss" scoped>
.client-main{
    display: block;
    margin: 120px auto; padding: 0 15px; max-width: 1230px; width: 100%;
}
@media(max-width:1200px){
    .client-main { margin: 45px auto 80px; }
}
</style>
